type ClarifyAnalyticsEvent =
  | 'clarify_form_shown'
  | 'clarify_form_submitted'
  | 'clarify_form_skipped'
  | 'clarify_form_error'
  | 'clarify_form_retry'
  | 'clarify_form_abandoned';

const EVENT_CATEGORY = 'Clarify Form';

const shouldLogToConsole = () => process.env.NODE_ENV === 'development';

const emitToGtag = (event: ClarifyAnalyticsEvent, payload?: Record<string, any>) => {
  if (typeof window === 'undefined') return;
  const gtag = (window as any)?.gtag;
  if (typeof gtag === 'function') {
    gtag('event', event, {
      event_category: EVENT_CATEGORY,
      ...payload,
    });
  }
};

export function trackClarifyEvent(event: ClarifyAnalyticsEvent, payload?: Record<string, any>) {
  try {
    emitToGtag(event, payload);
    if (shouldLogToConsole()) {
      // eslint-disable-next-line no-console
      console.log('[Clarify Analytics]', event, payload || {});
    }
  } catch {
    // Never let analytics break UX
  }
}
